<template>
  <div class="pt-3 pl-5 pr-5" :class="{ 'details-in-modal': modalMode }">
    <div class="mb-2" v-if="!modalMode">
        <breadCrumb :routesArray="routesArray"></breadCrumb>
    </div>
    <div v-if="isLoading">
      <div
        class="row w-full mb-3 justify-between flex"
        style="align-items: center"
      >
        <h1 class="title" v-if="!modalMode">Controls</h1>
        <div v-else></div>
        <div class="cardbody">
          <div class="flex flex-row-reverse items-center gap-3">
            <button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton'">
              <img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
              <img v-else src="@/assets/filter.svg" class="filterIcon" />
              Filters
            </button>
          </div>
        </div>
      </div>
      <div>
        <tableData
          :tableRowData="tableRow"
          :headersData="headers"
          :departmentArr="deptOptions"
          :loadData="dataLoading"
        ></tableData>
      </div>
      <popup v-if="showPopup" :popUp="showPopup">
        <!-- {{allKpis}} -->
        <template v-slot:header>
          <div class="flex items-center justify-between py-4 px-2 rounded">
            <h1 class="pl-2">
              {{ selectedControlObj.controlTitle }}
            </h1>
            <!-- <h1 class="pl-2" v-else>{{ allKpis.description }}</h1> -->
            <button class="float-right text-3xl" @click="showPopup = false">
              <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
            </button>
          </div>
        </template>
        <fieldset>
          <div class="statuscontainer popupbodycontainer">
            <div class="formcontainer flex flex-col">
              <div class="flex flex-row mt-3"> 
                  <div class="w-6/12">
                      <label class="font-semibold controllabel">CID</label>
                      <p class="text-sm mt-2">{{selectedControlObj.clientUniqueId != undefined ? selectedControlObj.clientUniqueId : 'N/A'}}</p>
                  </div>
                    <div class="w-6/12">
                      <label class="font-extrabold text-xs">Frequency</label>
                      <p class="text-sm mt-2" v-if="selectedControlObj.controlFrequency!= undefined&& selectedControlObj.controlFrequency!='' ">{{getControlFrequency(selectedControlObj.controlFrequency)}}</p>
                      <p class="text-sm mt-2" v-else>N/A</p>
                  </div> 
                  <!-- <div class="w-6/12">
                      <label class="font-extrabold text-xs">Control Title</label>
                      <p class="text-sm mt-2">{{presentControlObj.controlTitle!= undefined&&presentControlObj.controlTitle!= '' ? presentControlObj.controlTitle: 'N/A'}}</p>
                  </div>   -->  
              </div>  
              <div class="w-full mt-3">
                  <label class="font-extrabold text-xs">Description</label>
                      <p class="text-sm mt-2" v-if="selectedControlObj.Description!= undefined&& selectedControlObj.Description!='' ">{{selectedControlObj.Description}}</p>
                      <p class="text-sm mt-2" v-else>N/A</p>
              </div>
              <div class="flex flex-row mt-3"> 
                  <div class="w-6/12">
                      <label class="font-extrabold text-xs">Priority</label>
                      <!-- {{selectedControlObj.controlPriority}} -->
                      <div v-if="selectedControlObj.controlPriority && typeof selectedControlObj.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(selectedControlObj.controlPriority)">
                        <div class="text-xs" :class="colorLabelText(selectedControlObj.controlPriority)">
                          {{ getProirityLabel(selectedControlObj.controlPriority) }}
                        </div>
                      </div>
                      <div v-else class="text-sm mt-2">N/A</div>
                      <!-- <p class="text-sm mt-2">{{selectedControlObj.controlPriority != undefined ? selectedControlObj.controlPriority : 'N/A'}}</p> -->
                  </div>
                  
              </div> 
              <div class="flex flex-row mt-3"> 
                      <div class="w-6/12">
                      <label class="font-extrabold text-xs">Class</label>
                      <p class="text-sm mt-2">{{selectedControlObj.controlClass != undefined&& selectedControlObj.controlClass!='' ? selectedControlObj.controlClass : 'N/A'}}</p>
                    </div>
                    <div class="w-6/12">
                      <label class="font-extrabold text-xs">Family</label>
                      <p class="text-sm mt-2">{{selectedControlObj.controlFamily!= undefined && selectedControlObj.controlFamily!= '' ? selectedControlObj.controlFamily: 'N/A'}}</p>
                    </div>
                    <!-- {{ presentControlObj.owner }} -->
                        
                  
              </div> 
              <div class="flex flex-row mt-3"> 
                    
                  <div class="w-6/12">
                      <label class="font-extrabold text-xs">Type</label>
                      <p class="text-sm mt-2">{{selectedControlObj.controlType != undefined && selectedControlObj.controlType != ''? selectedControlObj.controlType : 'N/A'}}</p>
                  </div>
                  <div class="w-6/12">
                    <label class="font-extrabold text-xs">Owner</label>
                      <p class="text-sm mt-2" v-if="selectedControlObj.owner!= undefined">{{getOwnerName(selectedControlObj.owner)}}</p>
                      <p v-else class="text-sm mt-2">N/A</p>
                  </div> 
              </div> 
              <div class="flex flex-row mt-3"> 
                <div class="w-full">
                      <label class="font-extrabold text-xs">Policy/Procedure</label>
                      <p class="text-sm mt-2">{{selectedControlObj.controlPolicies != undefined && selectedControlObj.controlPolicies != '' ? selectedControlObj.controlPolicies : 'N/A'}}</p>
                  </div>
              </div>
              <div class="w-full mt-3">
                <label class="font-extrabold text-xs">Guidance</label>
                <p class="text-sm mt-2">{{selectedControlObj.controlGuidance!= undefined &&  selectedControlObj.controlGuidance!=''? selectedControlObj.controlGuidance: 'N/A'}}</p>

              </div>
              <div class="flex flex-row mt-3"> 
                  <div class="w-full">
                      <label class="font-extrabold text-xs">Task</label>
                      <p class="text-sm mt-2">{{selectedControlObj.controlMaintenanceTask!= undefined && selectedControlObj.controlMaintenanceTask!= ''? selectedControlObj.controlMaintenanceTask: 'N/A'}}</p>
                  </div>
              </div>
            </div>
          </div>
        </fieldset>
      </popup>
    </div>
    <!-- <loader v-if="showLoader" /> -->
  </div>
</template>
<style scoped>
.multiselect-tag {
  font-size: 12px;
  font-weight: 600;
}
.multiselect-tag.is-disabled {
  background-color: #059669 !important;
}
.multiselect.is-disabled {
  background-color: white !important;
}
</style>
<script lang="ts">
import * as XLSX from 'xlsx';
// import loader from "../../components/loader.vue";
import _ from "lodash";
import { defineComponent } from "vue";
import { emitter, toast } from "@/main";
import popup from "@/components/popup.vue";
import tableData from "@/components/tableData.vue";
import breadCrumb from '@/components/breadCrumb.vue';
import { mapGetters } from "vuex";
// import Multiselect from '@vueform/multiselect/src/Multiselect';
export default defineComponent({
  props: {
    complianceId: { type: [String, Number], default: null },
    modalMode: { type: Boolean, default: false },
  },
  emits: ['header-info', 'open-nested'],
  data(): any {
    return {
      headers: [
        "_id",
        "clientUniqueId",
        "activeControlsTitle",
        "tier",
        "tierTitle",
        "controlFrequency",
        "controlOwner",
        "KPIs"
      ],
      presentControlObj:{},
      isLoading: false,
      showLoader: false,
      systems:{},
      optionsUserArray:[],
      showFilters: false,
      hideFormula: false,
      showPopup: false,
      columnObject: false,
      tierTitle:[],
      dummyList: [],
      allKpisList: [],
      routesArray: [],
      tableRow: [],
      departmentsList: [],
      controlDepartmentArr: [],
      selectedControlObj: {},
      internalControlsDetailsArray: [],
      allEntities: [],
      entitiesArray: [],
      naDepartments: "",
      dataLoading:true,
      kpiList: [],
      deptOptions: [],
      allProjects:[],
      allKpis: {
        kpi_id: "",
        weightage: "",
        description: [],
      },
      tierTypes:[
      { id: 10107, value: "Activity" },
      { id: 10108, value: "System" },
      { id: 10109, value: "Project" }
    ],
      controlRecurringArray: [
        { label: "Daily", id: 1 },
        { label: "Weekly", id: 2 },
        { label: "Monthly", id: 3 },
        { label: "Quarterly", id: 4 },
        { label: "Half-Yearly", id: 5 },
        { label: "Yearly", id: 6 },
      ],
      allProjectList:[],
    };
  },
  components: {
    tableData,
    // loader,
    popup,
    breadCrumb
    // Multiselect
  },
  async mounted() {
    await this.fetchDepartmentsList();
    await this.getAllUsers();
    await this.getallEntities();
    await this.fetchAllKpisInfo();
    await this.fetchActivitiesList();
    await this.allActiveControls();
    await this.getOwnerName();
    await this.getAllSystems();
    await this.getAllProjects()
    await this.startSelectedCompliance(this.currentComplianceId);
    emitter.on("showKpisViewData", (isData: any) => {
      let comingId = isData.entityData._id;
      let showObj = this.controlObj.find((obj: any) => {
        return obj._id === comingId;
      });
      this.showEditPopUp(showObj, isData.indexx);
    });
    await this.makeTable();
    this.dataLoading = false;
  },
  created(){
    this.dataLoading = true;
    this.routesArray = [
      { name: "Compliance", routeName: "compliance" },
      { name: "Controls", routeName: "complianceControls" }
    ];  
  },
  computed: {
    ...mapGetters({
        dbPriority:'dbPriority',
    }),
    currentComplianceId(): any {
      return this.complianceId || this.$route.params.complianceId;
    },
  },
  methods: {
    showEditPopUp(obj: any, index: any) {
      this.showPopup = true;
      this.selectedControlObj = { ...obj };
      this.hideFormula = true;
      // if (this.tableRow[index].departments == 'N/A') {
      // 	this.naDepartments = this.tableRow[index].departments;
      // } else {
      // 	this.controlDepartmentArr = this.tableRow[index].departments;
      // }
      // if (Number.isInteger(obj.targetTimePeriod)) {
      // 	this.allKpis.targetTimePeriod = this.controlRecurringArray.find((itemOne: any) => {
      // 		return itemOne.id == obj.targetTimePeriod;
      // 	}).label;
      // }
      // if (Number.isInteger(obj.reportingFrequency)) {
      // 	this.allKpis.reportingFrequency = this.controlRecurringArray.find((itemOne: any) => {
      // 		return itemOne.id == obj.reportingFrequency;
      // 	}).label;
      // }
    },
    getOwnerName(name:any){      
      let matchedOwner = this.optionsUserArray.find((user:any)=>user.value==name);
      if(matchedOwner!=undefined){
        return matchedOwner.label
      }
      else{
        return 'N/A'
      }
    },
    colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
    getProirityLabel(val:any){
          if (val === 'N/A') { 
              return ''; 
          } else {
              let a = this.dbPriority.find((obj: any) => obj.value == val);
              return (val && typeof val === 'number') ? a.key : '';
          }
        },
    colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
    getControlFrequency(id:any){
      if(id != undefined || id != '' || id != null){
        let frequency:any = this.controlRecurringArray.find((data:any)=>{return data.id == id})
        return frequency.label
      } else {
        return 'N/A'
      }
     },
    filterOpen() {
			this.showFilters = !this.showFilters;
			emitter.emit("visible", this.showFilters);
		},
    async fetchAllKpisInfo() {
      try {
        await this.$http
          .get(`${process.env.VUE_APP_CONTROLS_API}/api/org/kpis/getall`)
          .then((result: { data: any }) => {
            this.isLoading = true;
            this.showLoader = true;
            this.allKpisList = result.data;
            _.each(
              this.allKpisList,
              (kpi: {
                kpis: any;
                controlNumber: any;
                controlTitle: any;
                departments: any;
              }) => {
                if (kpi.kpis) {
                  _.each(
                    kpi.kpis,
                    (kpi: {
                      controlNumber: any;
                      targetTimePeriod: any;
                      reportingFrequency: any;
                      controlTitle: any;
                      departments: any;
                    }) => {
                      // kpi.departments = kpi.departments;
                      this.kpiList.push(kpi);
                    }
                  );
                  this.dummyList = this.kpiList;
                }
              }
            );
          });
      } catch (e) {
        toast.error("error", {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
      this.showLoader = false;
    },
    async fetchDepartmentsList() {
      (this.showLoader = true),
        //  (this.isLoading = false);
        await this.$http
          .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
          .then((res: { data: any }) => {
            this.isLoading = true;
            this.showLoader = false;
            this.departmentsList = res.data;
          })
          .catch((error: any) => {
            this.isLoading = false;
            (this.showLoader = false),
              toast.error(`Save failed with ${error}`, {
                timeout: 1000,
                closeOnClick: true,
                closeButton: "button",
                icon: true,
              });
          });
    },
    async allActiveControls() {
        await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls`).then((res: any) => {
            this.allControlsList = res.data;
              this.controlObj=[...this.allControlsList] 
            this.presentControlObj =this.allControlsList.find((control:any)=>{
              control._id == this.$route.params.id});
            this.dummyCustomObj = {...this.presentControlObj}
            this.dummyControlObj={...this.controlsEditData};
            
        });
    },
    async getallEntities() {
      let result: any;
      await this.$http
        .get(
          `${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`
        )
        .then((res: any) => {
          result = res.data;
          this.allEntities = res.data;
        });
      for (var i = 0; i < result.length; i++) {
        this.entitiesArray.push({
          label: result[i].entityDisplayName,
          value: result[i]._id,
          entityType:result[i].entityType
        });
      }
    },
    async getAllProjects(){
			this.dataLoading = true;
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((res: any) => {
				this.allProjects = res.data;
      })
      this.allProjects.map((project:any)=>{
        this.allProjectList.push({label:project.projectName,value:project._id})
      })
  },
   async fetchActivitiesList() {
        try {
             let entityId='20006'
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((res: any) => {
            this.activitiesList = res.data;
        });
        } catch (e) {
            toast.error('error', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
        }
        this.showLoader = false;
    },
    async startSelectedCompliance(cameId:any){
			await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/compliance/${cameId}/startCompliance`).then((result: any) => {
        this.internalControlsDetailsArray = [...result.data];
			})
		},
    // makeTable() {
    //   let eachControlData: any
    //   this.internalControlsDetailsArray.forEach((controlData: any) => {
    //     console.log("controlData", controlData);
    //     eachControlData = controlData.controls
    //     // this.tableRow.push(finalKPIObj);
    //   });
    //   console.log("kpi")
    //   if(eachControlData.length != 0){
    //     eachControlData.forEach((kpi:any)=>{
    //       if(Object.keys(kpi).includes('kpis') && kpi.kpis.length !== 0){
    //         this.departmentsList.forEach((eachdepartment: any) => {
    //           if (kpi.departments == eachdepartment._id) {
    //             kpi.departments = eachdepartment.teamName;
    //           }
    //         });
    //         this.deptOptions = this.departmentsList.map((item: any) => {
    //           return { value: item._id, label: item.teamName };
    //         });
    //         let finalKPIObj
    //         kpi.kpis.map((eachKpi: any)=>{
    //           finalKPIObj = {
    //             _id: kpi._id,
    //             departments: kpi.departments ? kpi.departments : "N/A",
    //             number: kpi.controlNumber ? kpi.controlNumber : "N/A",
    //             "KPI Name": eachKpi.description,
    //             "weightage (%)": parseInt(eachKpi.weightage)
    //           };
    //         })
    //       this.tableRow.push(finalKPIObj);
    //       }
    //     })
    //   }
    // },
    async getAllUsers() {
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
            this.users = res.data;
        });
        for (var i = 0; i < this.users.length; i++) {
            this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
        }
    },
    async getAllSystems() {
        let entityId='20005'
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((res: any) => {
            this.systems = res.data;
        });
        // let systemId:any = this.$route.params.systemId
        // let data:any = this.systems.find((data:any)=>{
        //     return data._id == systemId
        // })
        // // console.log('Data');
        
        // this.systemObj = {...data}
    },
    makeTable() {
      this.internalControlsDetailsArray.forEach((controlData: any) => {
        let ObjectIncludedTier:any
        let tierTitle:any
        let kpisLength:any
        let tierLabelObj:any
        let owner:any;
        const eachControlData = controlData.controls;
        if (eachControlData && eachControlData.length) {
          eachControlData.forEach((control: any) => {
             let keysOfObject:any = Object.keys(control)          
              
            if(keysOfObject.includes('activityId')){
            ObjectIncludedTier = 10107            
            if(this.activitiesList && this.activitiesList.length>0 && control.activityId!=undefined){
                let matchedActivity = this.activitiesList.find((activity:any)=>activity._id.toString()==control.activityId.toString());
                if(matchedActivity!=undefined){
                    tierTitle = matchedActivity.businessProcessName
                    owner = matchedActivity.name
                }
            }            
          } else if(keysOfObject.includes('systemId')){
            ObjectIncludedTier = 10108
            if(this.systems.length>0 && control.systemId!=undefined){
                let matchedSystem = this.systems.find((sys:any)=>sys._id.toString()==control.systemId.toString());
                if(matchedSystem!=undefined){
                    tierTitle = matchedSystem.systemName
                    owner=matchedSystem.owner
                }
            }
          }else if(keysOfObject.includes('projectId')){
            ObjectIncludedTier = 10109
            if(this.allProjects.length>0 && control.projectId!=undefined){
                let matchedProject = this.allProjects.find((project:any)=>project._id.toString()==control.projectId.toString());
                if(matchedProject!=undefined){
                    tierTitle = matchedProject.projectName
                    owner=matchedProject.owner
                }
            }
          } else {
            ObjectIncludedTier ='N/A'
          }
          tierLabelObj = this.tierTypes.find((t:any) =>{ 
            return t.id == ObjectIncludedTier
            });
            if(control.isActive && control.isActive==true){
            let deptName = this.departmentsList.find((dept: any) => dept._id === control.departments);
            control.departments = deptName?.displayName || control.departments
            let entityName:any
            if(deptName && deptName.entityType == 20301){
              entityName = this.entitiesArray.find((e:any)=>e.entityType==1)?.label||'N/A'
            }
            else if (deptName && deptName.entityType == 20303){
              entityName = deptName.entityName != undefined ? deptName.entityDisplayName : 'N/A'
            }
            if(keysOfObject.includes('kpis')){
            kpisLength = control.kpis.length
          } else {
            kpisLength = 0
          } 
          let matchedOwner = this.optionsUserArray.find((user:any)=>user.value == owner);
            this.tableRow.push({
              _id: control._id,
            clientUniqueId: control.clientUniqueId != undefined || control.clientUniqueId != '' ? control.clientUniqueId :'N/A',
            activeControlsTitle: control.controlTitle != undefined || control.controlTitle != '' ? control.controlTitle : 'N/A',
            tier: tierLabelObj.id != undefined || tierLabelObj.id != '' ? tierLabelObj.id : 'N/A',
            tierTitle:tierTitle!=undefined&& tierTitle!=''?tierTitle:'N/A',
            controlFrequency:control.controlFrequency!=undefined|| control.controlFrequency!=''?control.controlFrequency:'N/A',
            controlOwner: matchedOwner != undefined && matchedOwner != '' ? matchedOwner.label : 'N/A',
            KPIs: kpisLength != undefined || kpisLength != '' ? kpisLength : 'N/A',
            });
            this.dataLoading = false;
            }
            // if (kpi.kpis && kpi.kpis.length) {
            //   kpi.departments = this.departmentsList.find((dept: any) => dept._id === kpi.departments)?.teamName || kpi.departments;
            //   this.deptOptions = this.departmentsList.map((item: any) => ({
            //     value: item._id,
            //     label: item.teamName
            //   }));
            //   kpi.kpis.forEach((eachKpi: any) => {
            //     this.tableRow.push({
            //       _id: kpi._id,
            //       departments: kpi.departments || "N/A",
            //       'Control Number': kpi.controlNumber || "N/A",
            //       "KPI Name": eachKpi.description,
            //       "weightage (%)": parseInt(eachKpi.weightage)
            //     });
            //   });
            // }
          });
        }
      });
      for (const row of this.tableRow) {
        for (const value of Object.values(row)) {
          if (value == "") {
            this.columnObject = true;
          } else {
            this.columnObject = false;
          }
        }
      }
    }
  },
});
</script>

